import { annuityPages } from './annuityPages';

export default {
  title: 'Annuities',
  pages: annuityPages,
};
